import { render, staticRenderFns } from "./salon-list.vue?vue&type=template&id=21fd0438&scoped=true&"
import script from "./salon-list.vue?vue&type=script&lang=js&"
export * from "./salon-list.vue?vue&type=script&lang=js&"
import style0 from "./salon-list.vue?vue&type=style&index=0&id=21fd0438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fd0438",
  null
  
)

export default component.exports